import React, { useRef } from "react";
// import Navbar from "../../components/Navbar/Navbar";
import Hero4 from "../../components/hero4/hero4";
import CoupleSection4 from "../../components/CoupleSection4/CoupleSection4";
// import VideoSection from "../../components/VideoSection";
// import StorySection4 from "../../components/StorySection4/StorySection4";
// import PortfolioSectionS2 from "../../components/PortfolioSectionS2/PortfolioSectionS2";
// import BrideGrooms2 from "../../components/BrideGrooms2";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
// import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import BottomSection from "../../components/BottomContainer/BottomContainer";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";

const ClassicElegance = () => {
  const containerRef = useRef();

  return (
    <div ref={containerRef} className={`fadeInSlow scroll-container`}>
      {/* <Navbar hclass={"wpo-header-style-3"} /> */}
      <Hero4 />
      {/* <PartnerSection /> */}
      <CoupleSection4 />
      <LetterEnvelope />
      <QuoteSection />
      <EventSection4 haveBackground={false} />
      <VenueSection />

      <RsvpSectionS2 />
      <InviteeSection haveBackground={false} />
      <BottomSection />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default ClassicElegance;
